var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConfirmationTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 147,
    viewBox: "0 0 146 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.0001 18.8899L72.4137 11.7364C72.3903 11.4159 72.6248 11.1266 72.9532 11.1032C73.2737 11.0797 73.563 11.3143 73.5864 11.6426C73.5864 11.6739 73.5864 11.7052 73.5864 11.7364L73.0001 18.8899Z",
    fill: "#E2E1E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7002 22.1394L93.6 15.2126C93.686 14.8999 94.0065 14.7122 94.3192 14.7982C94.632 14.8842 94.8196 15.2048 94.7336 15.5175C94.7258 15.5488 94.7101 15.58 94.7023 15.6113L91.7002 22.1394Z",
    fill: "#E2E1E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.885 31.4796L112.036 25.6239C112.224 25.3581 112.591 25.2955 112.857 25.4832C113.123 25.6708 113.185 26.0382 112.998 26.3041C112.982 26.3275 112.959 26.3588 112.935 26.3744L107.885 31.4796Z",
    fill: "#E2E1E8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.9 45.7999L125.803 41.711C126.069 41.5234 126.436 41.5938 126.624 41.8596C126.812 42.1254 126.741 42.4928 126.475 42.6805C126.452 42.6961 126.421 42.7117 126.389 42.7274L119.9 45.7999Z",
    fill: "#E2E1E8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.288 63.3615L133.231 61.5399C133.543 61.4539 133.864 61.6493 133.95 61.962C134.036 62.2748 133.84 62.5953 133.528 62.6813C133.496 62.6891 133.465 62.6969 133.434 62.6969L126.288 63.3615Z",
    fill: "#E2E1E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M126.288 82.6367L133.434 83.3013C133.754 83.3325 133.997 83.6218 133.965 83.9423C133.934 84.2629 133.645 84.5052 133.324 84.474C133.293 84.474 133.262 84.4661 133.231 84.4583L126.288 82.6367Z",
    fill: "#E2E1E8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M119.9 100.199L126.389 103.272C126.686 103.412 126.812 103.764 126.671 104.054C126.53 104.351 126.178 104.476 125.889 104.335C125.858 104.319 125.834 104.304 125.803 104.288L119.9 100.199Z",
    fill: "#E2E1E8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M107.885 114.523L112.935 119.629C113.162 119.863 113.162 120.231 112.927 120.457C112.693 120.684 112.325 120.684 112.099 120.45C112.075 120.426 112.052 120.403 112.036 120.379L107.885 114.523Z",
    fill: "#E2E1E8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7002 123.863L94.7023 130.384C94.8352 130.681 94.7101 131.032 94.4131 131.165C94.116 131.298 93.772 131.173 93.6312 130.876C93.6156 130.845 93.6078 130.814 93.6 130.782L91.7002 123.863Z",
    fill: "#E2E1E8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0014 127.109L73.5877 134.263C73.6112 134.583 73.3767 134.873 73.0483 134.896C72.7278 134.92 72.4385 134.685 72.415 134.357C72.415 134.325 72.415 134.294 72.415 134.263L73.0014 127.109Z",
    fill: "#E2E1E8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2994 123.863L52.3996 130.79C52.3136 131.103 51.9931 131.29 51.6726 131.204C51.3598 131.118 51.1722 130.798 51.2582 130.485C51.266 130.454 51.2816 130.423 51.2895 130.391L54.2994 123.863Z",
    fill: "#E2E1E8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1167 114.523L33.9653 120.379C33.7777 120.645 33.4102 120.708 33.1444 120.52C32.8786 120.332 32.816 119.965 33.0037 119.699C33.0193 119.676 33.0428 119.644 33.0662 119.629L38.1167 114.523Z",
    fill: "#E2E1E8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0996 100.199L20.197 104.288C19.9312 104.476 19.5637 104.405 19.3761 104.14C19.1884 103.874 19.2588 103.506 19.5246 103.319C19.5481 103.303 19.5793 103.287 19.6106 103.272L26.0996 100.199Z",
    fill: "#E2E1E8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7118 82.6367L12.7694 84.4583C12.4567 84.5443 12.1361 84.3489 12.0502 84.0362C11.9642 83.7234 12.1518 83.4029 12.4723 83.3169C12.5036 83.3091 12.5349 83.3013 12.5661 83.3013L19.7118 82.6367Z",
    fill: "#E2E1E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7123 63.3595L12.5666 62.695C12.246 62.6637 12.0037 62.3744 12.0349 62.0539C12.0662 61.7333 12.3555 61.491 12.676 61.5222C12.7073 61.5222 12.7386 61.5301 12.7698 61.5379L19.7123 63.3595Z",
    fill: "#E2E1E8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0987 45.799L19.6097 42.7265C19.3126 42.5857 19.1875 42.2339 19.3283 41.9447C19.469 41.6476 19.8208 41.5225 20.1101 41.6632C20.1413 41.6789 20.1648 41.6945 20.1961 41.7101L26.0987 45.799Z",
    fill: "#E2E1E8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.115 31.478L33.0646 26.3728C32.8379 26.1382 32.8379 25.7708 33.0724 25.5441C33.3069 25.3174 33.6744 25.3174 33.9011 25.5519C33.9246 25.5753 33.948 25.5988 33.9637 25.6223L38.115 31.478Z",
    fill: "#E2E1E8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3002 22.1362L51.298 15.616C51.1651 15.3189 51.2902 14.9749 51.5873 14.8342C51.8844 14.7013 52.2284 14.8264 52.3691 15.1234C52.3847 15.1547 52.3926 15.186 52.4004 15.2173L54.3002 22.1362Z",
    fill: "#E2E1E8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9081 28.4561L62.5157 18.1598C62.4454 17.8549 62.633 17.55 62.9379 17.4796C63.2428 17.4093 63.5477 17.5969 63.6181 17.9018C63.6259 17.9252 63.6259 17.9409 63.6259 17.9643L64.9081 28.4561Z",
    fill: "url(#paint0_linear_596_5603)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2414 33.79L44.4717 24.9322C44.2997 24.6664 44.3778 24.3146 44.6358 24.1426C44.9017 23.9706 45.2535 24.0487 45.4255 24.3067C45.4333 24.3224 45.4489 24.338 45.4567 24.3615L50.2414 33.79Z",
    fill: "url(#paint1_linear_596_5603)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2794 43.8224L29.8281 37.4663C29.5779 37.2787 29.5231 36.919 29.7186 36.6689C29.9062 36.4187 30.2659 36.364 30.516 36.5594C30.5317 36.5751 30.5473 36.5829 30.5629 36.5985L38.2794 43.8224Z",
    fill: "url(#paint2_linear_596_5603)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4784 57.3411L20.3619 54.2608C20.0648 54.167 19.8928 53.8543 19.9866 53.5494C20.0804 53.2523 20.3931 53.0803 20.698 53.1741C20.7215 53.1819 20.7371 53.1897 20.7528 53.1976L30.4784 57.3411Z",
    fill: "url(#paint3_linear_596_5603)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7645 73.0004L17.2101 73.5711C16.8974 73.5868 16.6316 73.3444 16.6081 73.0317C16.5925 72.719 16.8349 72.4531 17.1476 72.4297C17.171 72.4297 17.1867 72.4297 17.2101 72.4297L27.7645 73.0004Z",
    fill: "url(#paint4_linear_596_5603)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4783 88.6602L20.7527 92.8037C20.4634 92.9288 20.1272 92.7959 20.0099 92.5066C19.8849 92.2174 20.0178 91.8812 20.307 91.7639C20.3227 91.7561 20.3461 91.7483 20.3618 91.7405L30.4783 88.6602Z",
    fill: "url(#paint5_linear_596_5603)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2798 102.176L30.5556 109.4C30.3289 109.611 29.9692 109.603 29.7503 109.376C29.5392 109.149 29.547 108.79 29.7738 108.571C29.7894 108.555 29.805 108.547 29.8207 108.532L38.2798 102.176Z",
    fill: "url(#paint6_linear_596_5603)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2421 112.207L45.4575 121.636C45.3167 121.917 44.9727 122.026 44.6913 121.886C44.4098 121.745 44.3004 121.401 44.4411 121.12C44.4489 121.104 44.4646 121.081 44.4724 121.065L50.2421 112.207Z",
    fill: "url(#paint7_linear_596_5603)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9095 117.547L63.6352 128.047C63.5961 128.359 63.3147 128.578 63.0019 128.539C62.6892 128.5 62.4703 128.219 62.5094 127.906C62.5094 127.882 62.5172 127.867 62.5172 127.843L64.9095 117.547Z",
    fill: "url(#paint8_linear_596_5603)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0908 117.547L83.4831 127.843C83.5535 128.148 83.3659 128.453 83.061 128.523C82.7561 128.594 82.4512 128.406 82.3808 128.101C82.373 128.078 82.373 128.062 82.373 128.039L81.0908 117.547Z",
    fill: "url(#paint9_linear_596_5603)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7578 112.207L101.528 121.065C101.7 121.331 101.621 121.683 101.363 121.854C101.098 122.026 100.746 121.948 100.574 121.69C100.566 121.675 100.55 121.659 100.542 121.636L95.7578 112.207Z",
    fill: "url(#paint10_linear_596_5603)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M107.722 102.176L116.173 108.532C116.423 108.719 116.478 109.079 116.282 109.329C116.095 109.579 115.735 109.634 115.485 109.439C115.469 109.423 115.454 109.415 115.438 109.4L107.722 102.176Z",
    fill: "url(#paint11_linear_596_5603)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M115.523 88.6602L125.64 91.7405C125.937 91.8343 126.109 92.147 126.015 92.4519C125.921 92.749 125.609 92.921 125.304 92.8272C125.288 92.8194 125.265 92.8115 125.249 92.8037L115.523 88.6602Z",
    fill: "url(#paint12_linear_596_5603)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M118.235 73.0011L128.798 72.4304C129.11 72.4148 129.376 72.6571 129.4 72.9698C129.415 73.2826 129.173 73.5484 128.86 73.5718C128.837 73.5718 128.821 73.5718 128.798 73.5718L118.235 73.0011Z",
    fill: "url(#paint13_linear_596_5603)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M115.523 57.339L125.249 53.1955C125.538 53.0704 125.875 53.2033 125.992 53.4926C126.117 53.7818 125.984 54.118 125.695 54.2353C125.679 54.2431 125.656 54.2509 125.64 54.2587L115.523 57.339Z",
    fill: "url(#paint14_linear_596_5603)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M107.722 43.8258L115.446 36.6019C115.673 36.3908 116.032 36.3986 116.251 36.6253C116.462 36.8521 116.454 37.2117 116.228 37.4306C116.212 37.4462 116.196 37.454 116.181 37.4697L107.722 43.8258Z",
    fill: "url(#paint15_linear_596_5603)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7578 33.7908L100.55 24.3622C100.691 24.0807 101.035 23.9713 101.316 24.112C101.598 24.2527 101.707 24.5967 101.567 24.8782C101.559 24.8938 101.543 24.9173 101.535 24.9329L95.7578 33.7908Z",
    fill: "url(#paint16_linear_596_5603)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M81.0908 28.4537L82.3652 17.9541C82.4043 17.6414 82.6857 17.4225 82.9984 17.4615C83.3111 17.5006 83.5301 17.7821 83.491 18.0948C83.491 18.1183 83.4831 18.1339 83.4831 18.1574L81.0908 28.4537Z",
    fill: "url(#paint17_linear_596_5603)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0534 72.9985L46.418 73.5848C46.0975 73.6395 45.7926 73.4206 45.7379 73.0923C45.6831 72.7717 45.9021 72.4668 46.2304 72.4121C46.293 72.4043 46.3633 72.4043 46.418 72.4121L50.0534 72.9985Z",
    fill: "url(#paint18_linear_596_5603)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M51.422 81.0469L48.2087 82.8372C47.9195 82.9936 47.5599 82.8919 47.4035 82.6105C47.2471 82.3212 47.3488 81.9616 47.6302 81.8052C47.6849 81.774 47.7475 81.7505 47.81 81.7427L51.422 81.0469Z",
    fill: "url(#paint19_linear_596_5603)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3545 87.8555L52.9466 90.6387C52.7355 90.8889 52.3602 90.9123 52.11 90.7012C51.8599 90.4902 51.8364 90.1149 52.0475 89.8647C52.0866 89.8178 52.1413 89.7709 52.196 89.7396L55.3545 87.8555Z",
    fill: "url(#paint20_linear_596_5603)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3835 92.9102L60.0779 96.3501C59.9606 96.655 59.6166 96.8114 59.3117 96.6941C59.0068 96.5768 58.8505 96.2328 58.9677 95.9279C58.9912 95.8654 59.0225 95.8106 59.0616 95.7637L61.3835 92.9102Z",
    fill: "url(#paint21_linear_596_5603)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M68.7704 95.6016L68.7157 99.2839C68.7079 99.6122 68.4421 99.8702 68.1137 99.8702C67.7853 99.8624 67.5273 99.5966 67.5273 99.2682C67.5273 99.2057 67.543 99.1431 67.5586 99.0806L68.7704 95.6016Z",
    fill: "url(#paint22_linear_596_5603)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M77.2305 95.6016L78.4423 99.0728C78.5517 99.3855 78.3875 99.7217 78.0748 99.8311C77.7621 99.9406 77.4259 99.7764 77.3165 99.4637C77.293 99.4011 77.2852 99.3386 77.2852 99.276L77.2305 95.6016Z",
    fill: "url(#paint23_linear_596_5603)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6172 92.9102L86.9391 95.7637C87.1502 96.0217 87.1111 96.3892 86.8531 96.6003C86.5952 96.8114 86.2277 96.7723 86.0166 96.5143C85.9775 96.4674 85.9463 96.4048 85.9228 96.3501L84.6172 92.9102Z",
    fill: "url(#paint24_linear_596_5603)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6455 87.8555L93.804 89.7396C94.0854 89.9038 94.1793 90.2712 94.0073 90.5527C93.8431 90.8341 93.4756 90.928 93.1942 90.756C93.1395 90.7247 93.0926 90.6778 93.0456 90.6309L90.6455 87.8555Z",
    fill: "url(#paint25_linear_596_5603)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5771 81.0469L98.1891 81.7349C98.5096 81.7974 98.7207 82.1101 98.6582 82.4307C98.5956 82.7512 98.2829 82.9623 97.9624 82.8998C97.8998 82.8841 97.8373 82.8607 97.7825 82.8372L94.5771 81.0469Z",
    fill: "url(#paint26_linear_596_5603)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M95.9463 73.001L99.5739 72.4146C99.8944 72.3599 100.199 72.5788 100.254 72.9072C100.309 73.2277 100.09 73.5326 99.7615 73.5873C99.699 73.5952 99.6286 73.5952 99.5739 73.5873L95.9463 73.001Z",
    fill: "url(#paint27_linear_596_5603)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M94.5771 64.9575L97.7904 63.1672C98.0796 63.0108 98.4393 63.1124 98.5956 63.3939C98.752 63.6832 98.6503 64.0428 98.3689 64.1991C98.3142 64.2304 98.2516 64.2539 98.1891 64.2617L94.5771 64.9575Z",
    fill: "url(#paint28_linear_596_5603)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6455 58.1452L93.0535 55.362C93.2645 55.1118 93.6398 55.0884 93.89 55.2995C94.1402 55.5105 94.1636 55.8858 93.9525 56.136C93.9134 56.1829 93.8587 56.2298 93.804 56.2611L90.6455 58.1452Z",
    fill: "url(#paint29_linear_596_5603)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M84.625 53.0847L85.9306 49.6447C86.0479 49.3398 86.3919 49.1835 86.6968 49.3007C87.0017 49.418 87.158 49.762 87.0408 50.0669C87.0173 50.1295 86.986 50.1842 86.947 50.2311L84.625 53.0847Z",
    fill: "url(#paint30_linear_596_5603)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7578 100.066L101.52 106.024C101.746 106.258 101.739 106.626 101.504 106.852C101.27 107.079 100.902 107.071 100.675 106.837C100.66 106.821 100.636 106.798 100.621 106.774L95.7578 100.066Z",
    fill: "url(#paint31_linear_596_5603)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M73 37.7579L72.4137 29.4864C72.3902 29.1658 72.6326 28.8844 72.9609 28.8609C73.2815 28.8375 73.5629 29.0798 73.5864 29.4082C73.5864 29.4317 73.5864 29.4629 73.5864 29.4942L73 37.7579Z",
    fill: "url(#paint32_linear_596_5603)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7571 39.8661L57.3719 32.2904C57.239 31.9933 57.3719 31.6493 57.669 31.5164C57.966 31.3835 58.31 31.5164 58.4429 31.8135C58.4508 31.8369 58.4664 31.8682 58.4742 31.8917L60.7571 39.8661Z",
    fill: "url(#paint33_linear_596_5603)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2426 45.9318L44.4729 39.9744C44.2462 39.7399 44.254 39.3725 44.4885 39.1457C44.7231 38.919 45.0905 38.9268 45.3172 39.1614C45.3329 39.177 45.3563 39.2005 45.372 39.2239L50.2426 45.9318Z",
    fill: "url(#paint34_linear_596_5603)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4384 55.2292L34.98 51.6016C34.6907 51.4609 34.5656 51.1091 34.7064 50.812C34.8471 50.5228 35.1989 50.3977 35.496 50.5384C35.5194 50.554 35.5429 50.5618 35.5663 50.5775L42.4384 55.2292Z",
    fill: "url(#paint35_linear_596_5603)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2883 66.6371L30.0403 65.7771C29.7197 65.7458 29.4852 65.4565 29.5165 65.1282C29.5477 64.8076 29.837 64.5731 30.1654 64.6044C30.1888 64.6044 30.2201 64.6122 30.2435 64.62L38.2883 66.6371Z",
    fill: "url(#paint36_linear_596_5603)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2876 79.3633L30.2428 81.3803C29.9301 81.4585 29.6095 81.2709 29.5314 80.9503C29.4532 80.6376 29.6408 80.3171 29.9614 80.2389C29.9848 80.2311 30.0161 80.2311 30.0395 80.2233L38.2876 79.3633Z",
    fill: "url(#paint37_linear_596_5603)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4391 90.7695L35.567 95.4134C35.3012 95.5933 34.9337 95.5229 34.7539 95.2571C34.5741 94.9913 34.6445 94.6238 34.9103 94.444C34.9337 94.4284 34.9572 94.4127 34.9807 94.4049L42.4391 90.7695Z",
    fill: "url(#paint38_linear_596_5603)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2429 100.066L45.3801 106.782C45.1924 107.048 44.825 107.103 44.5592 106.915C44.2934 106.727 44.2386 106.36 44.4263 106.094C44.4419 106.071 44.4654 106.047 44.481 106.032L50.2429 100.066Z",
    fill: "url(#paint39_linear_596_5603)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7485 106.129L58.4734 114.103C58.3874 114.416 58.0591 114.596 57.7464 114.51C57.4336 114.424 57.2538 114.095 57.3398 113.783C57.3476 113.759 57.3555 113.728 57.3711 113.705L60.7485 106.129Z",
    fill: "url(#paint40_linear_596_5603)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0014 108.246L73.5877 116.518C73.6112 116.838 73.3688 117.12 73.0405 117.143C72.7199 117.166 72.4385 116.924 72.415 116.596C72.415 116.572 72.415 116.541 72.415 116.51L73.0014 108.246Z",
    fill: "url(#paint41_linear_596_5603)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M85.25 106.129L88.6274 113.697C88.7603 113.994 88.6274 114.338 88.3303 114.471C88.0332 114.604 87.6892 114.471 87.5563 114.174C87.5485 114.15 87.5329 114.119 87.525 114.095L85.25 106.129Z",
    fill: "url(#paint42_linear_596_5603)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M103.562 90.7695L111.02 94.3971C111.309 94.5378 111.434 94.8896 111.294 95.1867C111.153 95.476 110.801 95.6011 110.504 95.4604C110.48 95.4447 110.457 95.4369 110.434 95.4213L103.562 90.7695Z",
    fill: "url(#paint43_linear_596_5603)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M107.712 79.3633L115.96 80.2233C116.28 80.2545 116.515 80.5438 116.484 80.8722C116.452 81.1927 116.163 81.4272 115.835 81.396C115.811 81.396 115.78 81.3882 115.749 81.3803L107.712 79.3633Z",
    fill: "url(#paint44_linear_596_5603)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M107.712 66.6363L115.757 64.6193C116.069 64.5411 116.39 64.7287 116.468 65.0492C116.546 65.362 116.359 65.6825 116.038 65.7607C116.015 65.7685 115.983 65.7685 115.952 65.7763L107.712 66.6363Z",
    fill: "url(#paint45_linear_596_5603)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M103.562 55.2318L110.434 50.5879C110.699 50.4081 111.067 50.4785 111.247 50.7443C111.426 51.0101 111.356 51.3775 111.09 51.5574C111.067 51.573 111.043 51.5886 111.02 51.5964L103.562 55.2318Z",
    fill: "url(#paint46_linear_596_5603)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7578 45.936L100.628 39.2203C100.816 38.9545 101.184 38.8998 101.449 39.0874C101.715 39.275 101.77 39.6425 101.582 39.9083C101.567 39.9317 101.551 39.9552 101.528 39.9708L95.7578 45.936Z",
    fill: "url(#paint47_linear_596_5603)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M85.25 39.8672L87.525 31.8928C87.611 31.5801 87.9394 31.4003 88.2521 31.4863C88.5649 31.5723 88.7447 31.9007 88.6587 32.2134C88.6508 32.2368 88.643 32.2681 88.6274 32.2916L85.25 39.8672Z",
    fill: "url(#paint48_linear_596_5603)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4173 8.76719L65.9163 0.698968C65.8537 0.378428 66.0648 0.0735248 66.3853 0.0109805C66.7059 -0.0515638 67.0108 0.159523 67.0733 0.480063C67.0811 0.503517 67.0811 0.534789 67.0811 0.566061L67.4173 8.76719Z",
    fill: "#E2E1E8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3946 10.6583L53.5175 2.97316C53.4003 2.66825 53.5566 2.33208 53.8615 2.21481C54.1664 2.09754 54.5026 2.2539 54.6199 2.5588C54.6277 2.58225 54.6355 2.61353 54.6433 2.63698L56.3946 10.6583Z",
    fill: "url(#paint49_linear_596_5603)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M45.863 14.434L41.696 7.3587C41.5318 7.07725 41.6257 6.71762 41.9071 6.55344C42.1886 6.38926 42.5482 6.48308 42.7124 6.76453C42.728 6.78798 42.7358 6.81926 42.7515 6.84271L45.863 14.434Z",
    fill: "#E2E1E8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1532 19.9776L30.8213 13.7388C30.6102 13.4887 30.6414 13.1212 30.8838 12.9101C31.134 12.699 31.5014 12.7303 31.7125 12.9727C31.7281 12.9961 31.7516 13.0196 31.7594 13.043L36.1532 19.9776Z",
    fill: "url(#paint50_linear_596_5603)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5533 27.1332L21.2207 21.9107C20.9705 21.7075 20.9314 21.3322 21.1425 21.082C21.3458 20.8319 21.7211 20.7928 21.9712 21.0039C21.9947 21.0195 22.0103 21.0429 22.0338 21.0586L27.5533 27.1332Z",
    fill: "#E2E1E8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M20.3311 35.6605L13.1854 31.6186C12.9039 31.4622 12.8023 31.1026 12.9665 30.8133C13.1229 30.5319 13.4825 30.4302 13.7718 30.5944C13.7952 30.6101 13.8187 30.6257 13.8421 30.6413L20.3311 35.6605Z",
    fill: "url(#paint51_linear_596_5603)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M14.694 45.3141L6.95416 42.5777C6.64926 42.4683 6.48508 42.1321 6.59453 41.8272C6.70398 41.5223 7.04016 41.3581 7.34506 41.4676C7.36852 41.4754 7.39979 41.491 7.42324 41.4988L14.694 45.3141Z",
    fill: "#E2E1E8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8153 55.807L2.71576 54.4545C2.39522 54.3998 2.17632 54.0949 2.23105 53.7744C2.28577 53.4538 2.59068 53.2349 2.91122 53.2896C2.93467 53.2975 2.96594 53.2975 2.9894 53.3131L10.8153 55.807Z",
    fill: "url(#paint52_linear_596_5603)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M8.82167 66.8484L0.612726 66.9266C0.284368 66.9266 0.0263727 66.6686 0.0185547 66.3403C0.0185547 66.0119 0.27655 65.7461 0.604908 65.7461C0.63618 65.7461 0.659634 65.7461 0.690906 65.7539L8.82167 66.8484Z",
    fill: "#E2E1E8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M8.76719 78.582L0.698968 80.0831C0.378428 80.1456 0.0735248 79.9346 0.0109805 79.614C-0.0515638 79.2935 0.159523 78.9886 0.480063 78.926C0.503517 78.9182 0.534789 78.9182 0.566061 78.9182L8.76719 78.582Z",
    fill: "url(#paint53_linear_596_5603)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6593 89.6016L2.97413 92.4786C2.66923 92.5959 2.33305 92.4395 2.21578 92.1346C2.09851 91.8297 2.25487 91.4935 2.55978 91.3763C2.58323 91.3684 2.6145 91.3606 2.63796 91.3528L10.6593 89.6016Z",
    fill: "#E2E1E8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M14.434 100.137L7.3587 104.304C7.07725 104.468 6.71762 104.374 6.55344 104.093C6.38926 103.811 6.48308 103.452 6.76453 103.287C6.78798 103.272 6.81144 103.264 6.84271 103.248L14.434 100.137Z",
    fill: "url(#paint54_linear_596_5603)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9776 109.848L13.7388 115.18C13.4887 115.391 13.1212 115.359 12.9101 115.117C12.699 114.867 12.7303 114.499 12.9727 114.288C12.9961 114.273 13.0196 114.249 13.043 114.241L19.9776 109.848Z",
    fill: "#E2E1E8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1322 118.445L21.9098 124.778C21.7065 125.028 21.3312 125.067 21.0811 124.856C20.8309 124.653 20.7918 124.278 21.0029 124.027C21.0185 124.004 21.042 123.988 21.0576 123.965L27.1322 118.445Z",
    fill: "url(#paint55_linear_596_5603)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6605 125.668L31.6186 132.814C31.4622 133.095 31.1026 133.197 30.8133 133.033C30.5319 132.876 30.4302 132.517 30.5944 132.227C30.6101 132.204 30.6257 132.18 30.6413 132.157L35.6605 125.668Z",
    fill: "#E2E1E8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M45.316 131.305L42.5797 139.045C42.4702 139.349 42.1341 139.514 41.8292 139.404C41.5243 139.295 41.3601 138.959 41.4695 138.654C41.4774 138.63 41.493 138.599 41.5008 138.575L45.316 131.305Z",
    fill: "url(#paint56_linear_596_5603)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M55.808 135.184L54.4555 143.283C54.4008 143.604 54.0959 143.823 53.7753 143.768C53.4548 143.713 53.2359 143.408 53.2906 143.088C53.2984 143.064 53.3063 143.033 53.3063 143.009L55.808 135.184Z",
    fill: "#E2E1E8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8465 137.18L66.9169 145.389C66.9169 145.717 66.6589 145.983 66.3305 145.983C66.0021 145.983 65.7363 145.725 65.7363 145.396C65.7363 145.365 65.7363 145.342 65.7441 145.31L66.8465 137.18Z",
    fill: "url(#paint57_linear_596_5603)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M78.582 137.234L80.0753 145.303C80.1378 145.623 79.9267 145.928 79.6062 145.991C79.2857 146.053 78.9808 145.842 78.9182 145.521C78.9104 145.498 78.9104 145.467 78.9104 145.435L78.582 137.234Z",
    fill: "#E2E1E8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6055 135.34L92.4825 143.025C92.5998 143.33 92.4434 143.666 92.1385 143.783C91.8336 143.901 91.4974 143.744 91.3802 143.439C91.3724 143.416 91.3645 143.385 91.3567 143.361L89.6055 135.34Z",
    fill: "url(#paint58_linear_596_5603)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M100.138 131.562L104.305 138.638C104.469 138.919 104.375 139.279 104.094 139.443C103.812 139.607 103.453 139.513 103.288 139.232C103.273 139.209 103.265 139.185 103.249 139.154L100.138 131.562Z",
    fill: "#E2E1E8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M109.846 126.02L115.178 132.258C115.389 132.509 115.357 132.876 115.115 133.087C114.865 133.298 114.497 133.267 114.286 133.024C114.271 133.001 114.247 132.978 114.239 132.954L109.846 126.02Z",
    fill: "url(#paint59_linear_596_5603)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M118.446 118.867L124.779 124.09C125.029 124.293 125.068 124.668 124.857 124.918C124.654 125.169 124.279 125.208 124.028 124.997C124.005 124.981 123.989 124.957 123.966 124.942L118.446 118.867Z",
    fill: "#E2E1E8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M125.671 110.34L132.817 114.382C133.098 114.538 133.2 114.898 133.043 115.187C132.887 115.468 132.527 115.57 132.238 115.406C132.215 115.39 132.191 115.375 132.168 115.359L125.671 110.34Z",
    fill: "url(#paint60_linear_596_5603)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M131.307 100.684L139.047 103.42C139.351 103.529 139.516 103.866 139.406 104.17C139.297 104.475 138.961 104.64 138.656 104.53C138.632 104.522 138.601 104.507 138.577 104.499L131.307 100.684Z",
    fill: "#E2E1E8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M135.186 90.1953L143.285 91.5478C143.606 91.6026 143.824 91.9075 143.77 92.228C143.715 92.5485 143.41 92.7675 143.09 92.7127C143.066 92.7049 143.035 92.6971 143.011 92.6893L135.186 90.1953Z",
    fill: "url(#paint61_linear_596_5603)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M137.178 79.1563L145.387 79.0859C145.715 79.0859 145.981 79.3439 145.981 79.6723C145.981 80.0006 145.723 80.2665 145.394 80.2665C145.363 80.2665 145.34 80.2665 145.308 80.2586L137.178 79.1563Z",
    fill: "#E2E1E8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M137.232 67.4183L145.301 65.925C145.621 65.8625 145.926 66.0736 145.989 66.3941C146.051 66.7147 145.84 67.0196 145.52 67.0821C145.496 67.0899 145.465 67.0899 145.434 67.0899L137.232 67.4183Z",
    fill: "url(#paint62_linear_596_5603)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M135.342 56.3965L143.027 53.5195C143.332 53.4022 143.668 53.5586 143.785 53.8635C143.903 54.1684 143.746 54.5046 143.441 54.6218C143.418 54.6297 143.387 54.6375 143.363 54.6453L135.342 56.3965Z",
    fill: "#E2E1E8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M131.566 45.865L138.642 41.698C138.923 41.5338 139.283 41.6276 139.447 41.9091C139.611 42.1905 139.517 42.5501 139.236 42.7143C139.212 42.73 139.189 42.7378 139.158 42.7534L131.566 45.865Z",
    fill: "url(#paint63_linear_596_5603)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M126.022 36.1561L132.261 30.8242C132.511 30.6131 132.879 30.6444 133.09 30.8867C133.301 31.1369 133.27 31.5043 133.027 31.7154C133.004 31.7311 132.981 31.7545 132.957 31.7623L126.022 36.1561Z",
    fill: "#E2E1E8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M118.868 27.5514L124.091 21.2188C124.294 20.9686 124.669 20.9295 124.919 21.1406C125.17 21.3438 125.209 21.7191 124.998 21.9693C124.982 21.9927 124.958 22.0084 124.943 22.0318L118.868 27.5514Z",
    fill: "url(#paint64_linear_596_5603)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M110.339 20.3262L114.381 13.1805C114.537 12.8991 114.897 12.7974 115.186 12.9616C115.468 13.118 115.569 13.4776 115.405 13.7591C115.389 13.7825 115.374 13.806 115.358 13.8294L110.339 20.3262Z",
    fill: "#E2E1E8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M100.684 14.6921L103.42 6.95221C103.529 6.6473 103.866 6.48313 104.17 6.59258C104.475 6.70203 104.64 7.03821 104.53 7.34311C104.522 7.36656 104.507 7.39784 104.499 7.42129L100.684 14.6921Z",
    fill: "url(#paint65_linear_596_5603)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M90.1914 10.8153L91.5439 2.71576C91.5987 2.39522 91.9036 2.17632 92.2241 2.23105C92.5446 2.28577 92.7635 2.59068 92.7088 2.91122C92.701 2.93467 92.6932 2.96594 92.6932 2.9894L90.1914 10.8153Z",
    fill: "#E2E1E8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1524 8.82265L79.082 0.613702C79.082 0.285345 79.34 0.0195312 79.6684 0.0195312C79.9967 0.0195312 80.2626 0.277527 80.2626 0.605884C80.2626 0.637156 80.2626 0.660611 80.2547 0.691883L79.1524 8.82265Z",
    fill: "url(#paint66_linear_596_5603)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1466 72.7548C31.1466 49.7758 49.7758 31.1466 72.7548 31.1466C95.7338 31.1466 114.363 49.7758 114.363 72.7548C114.363 95.7338 95.7338 114.363 72.7548 114.363C49.7758 114.363 31.1466 95.7338 31.1466 72.7548Z",
    fill: "url(#paint67_radial_596_5603)",
    stroke: "white",
    strokeWidth: 5.84
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3203 73.2839L68.6835 80.7882L83.3308 65.2148",
    stroke: "white",
    strokeWidth: 8.76,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_596_5603",
    x1: 62.2036,
    y1: 17.248,
    x2: 58.4214,
    y2: 19.5885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_596_5603",
    x1: 43.6558,
    y1: 23.8587,
    x2: 40.3832,
    y2: 29.4239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_596_5603",
    x1: 28.5285,
    y1: 36.2958,
    x2: 26.9619,
    y2: 41.5005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_596_5603",
    x1: 18.6617,
    y1: 53.0657,
    x2: 18.2157,
    y2: 56.2271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_596_5603",
    x1: 16.5835,
    y1: 73.0898,
    x2: 17.275,
    y2: 76.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_596_5603",
    x1: 23.2693,
    y1: 92.7036,
    x2: 23.1478,
    y2: 89.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_596_5603",
    x1: 32.3276,
    y1: 109.293,
    x2: 31.8745,
    y2: 104.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_596_5603",
    x1: 46.2232,
    y1: 121.605,
    x2: 45.0797,
    y2: 115.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_596_5603",
    x1: 62.4997,
    y1: 123.902,
    x2: 65.9753,
    y2: 124.272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_596_5603",
    x1: 81.8477,
    y1: 128.152,
    x2: 78.8976,
    y2: 122.135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_596_5603",
    x1: 97.6009,
    y1: 121.604,
    x2: 96.4575,
    y2: 115.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_596_5603",
    x1: 110.451,
    y1: 109.298,
    x2: 109.997,
    y2: 104.327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_596_5603",
    x1: 118.831,
    y1: 92.7056,
    x2: 118.709,
    y2: 89.8637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_596_5603",
    x1: 128.972,
    y1: 72.5025,
    x2: 128.854,
    y2: 74.0669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_596_5603",
    x1: 125.635,
    y1: 53.4156,
    x2: 124.071,
    y2: 58.7275,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_596_5603",
    x1: 116.071,
    y1: 36.9195,
    x2: 111.494,
    y2: 44.2071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_596_5603",
    x1: 101.403,
    y1: 24.6718,
    x2: 94.8313,
    y2: 30.0299,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_596_5603",
    x1: 83.4032,
    y1: 18.1581,
    x2: 79.2822,
    y2: 19.3773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_596_5603",
    x1: 47.0891,
    y1: 73.5515,
    x2: 47.0654,
    y2: 72.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_596_5603",
    x1: 48.6167,
    y1: 82.8452,
    x2: 48.555,
    y2: 81.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_596_5603",
    x1: 52.9892,
    y1: 90.7395,
    x2: 52.802,
    y2: 88.7272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_596_5603",
    x1: 59.7006,
    y1: 96.5989,
    x2: 59.2783,
    y2: 94.0734,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_596_5603",
    x1: 67.9182,
    y1: 99.7203,
    x2: 66.9774,
    y2: 97.1684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_596_5603",
    x1: 77.6222,
    y1: 99.7153,
    x2: 76.6849,
    y2: 97.1645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_596_5603",
    x1: 85.3901,
    y1: 96.6019,
    x2: 84.9676,
    y2: 94.0743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_596_5603",
    x1: 91.7297,
    y1: 90.7374,
    x2: 91.5427,
    y2: 88.7265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_596_5603",
    x1: 95.8638,
    y1: 82.8453,
    x2: 95.8021,
    y2: 81.5826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_596_5603",
    x1: 97.3034,
    y1: 73.5515,
    x2: 97.2797,
    y2: 72.7462,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_596_5603",
    x1: 95.8638,
    y1: 64.892,
    x2: 95.802,
    y2: 63.6294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_596_5603",
    x1: 91.7304,
    y1: 58.0403,
    x2: 91.5432,
    y2: 56.0279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_596_5603",
    x1: 85.3969,
    y1: 52.9504,
    x2: 84.9746,
    y2: 50.425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_596_5603",
    x1: 97.6215,
    y1: 106.774,
    x2: 97.0364,
    y2: 102.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_596_5603",
    x1: 72.267,
    y1: 28.6839,
    x2: 70.0269,
    y2: 29.5191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_596_5603",
    x1: 56.8958,
    y1: 31.2991,
    x2: 53.699,
    y2: 34.9942,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_596_5603",
    x1: 43.5745,
    y1: 38.8434,
    x2: 41.6835,
    y2: 43.4053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_596_5603",
    x1: 33.6861,
    y1: 50.3868,
    x2: 32.9333,
    y2: 53.8763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_596_5603",
    x1: 29.4948,
    y1: 65.7779,
    x2: 31.8709,
    y2: 70.7609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_596_5603",
    x1: 29.4948,
    y1: 80.5392,
    x2: 31.8697,
    y2: 85.5209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_596_5603",
    x1: 37.1021,
    y1: 95.3465,
    x2: 36.8923,
    y2: 92.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_596_5603",
    x1: 46.1792,
    y1: 106.781,
    x2: 45.5928,
    y2: 102.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_596_5603",
    x1: 58.3969,
    y1: 114.236,
    x2: 56.9934,
    y2: 108.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_596_5603",
    x1: 72.7843,
    y1: 116.832,
    x2: 69.8261,
    y2: 113.196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_596_5603",
    x1: 86.3282,
    y1: 114.228,
    x2: 84.9271,
    y2: 108.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_596_5603",
    x1: 106.011,
    y1: 95.3515,
    x2: 105.801,
    y2: 92.1405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_596_5603",
    x1: 110.471,
    y1: 81.3273,
    x2: 110.437,
    y2: 79.9459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_596_5603",
    x1: 116.149,
    y1: 64.7313,
    x2: 115.682,
    y2: 67.4542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_596_5603",
    x1: 111.048,
    y1: 50.7907,
    x2: 108.601,
    y2: 56.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_596_5603",
    x1: 101.465,
    y1: 39.4203,
    x2: 96.7205,
    y2: 44.8951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_596_5603",
    x1: 88.5485,
    y1: 32.0006,
    x2: 83.6499,
    y2: 34.7061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_596_5603",
    x1: 53.1183,
    y1: 2.00847,
    x2: 49.858,
    y2: 5.17534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_596_5603",
    x1: 30.0046,
    y1: 12.6274,
    x2: 27.8819,
    y2: 17.181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_596_5603",
    x1: 11.9682,
    y1: 30.4141,
    x2: 11.055,
    y2: 34.1473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_596_5603",
    x1: 1.16119,
    y1: 53.2314,
    x2: 0.961277,
    y2: 55.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_596_5603",
    x1: -0.0188146,
    y1: 79.4559,
    x2: 1.41202,
    y2: 83.4919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_596_5603",
    x1: 6.45557,
    y1: 102.592,
    x2: 12.8101,
    y2: 108.386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_596_5603",
    x1: 22.8365,
    y1: 124.763,
    x2: 22.3439,
    y2: 120.372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_596_5603",
    x1: 41.4272,
    y1: 136.005,
    x2: 46.8094,
    y2: 137.254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_596_5603",
    x1: 66.1075,
    y1: 145.674,
    x2: 63.191,
    y2: 142.031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_596_5603",
    x1: 90.5224,
    y1: 143.524,
    x2: 88.8833,
    y2: 138.276,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_596_5603",
    x1: 111.566,
    y1: 132.974,
    x2: 110.888,
    y2: 128.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_596_5603",
    x1: 128.012,
    y1: 115.304,
    x2: 127.754,
    y2: 111.829,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_596_5603",
    x1: 137.887,
    y1: 92.6324,
    x2: 137.833,
    y2: 90.9189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.951959,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_596_5603",
    x1: 145.663,
    y1: 66.01,
    x2: 145.405,
    y2: 68.0493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_596_5603",
    x1: 139.222,
    y1: 41.888,
    x2: 137.225,
    y2: 46.952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_596_5603",
    x1: 124.894,
    y1: 21.4214,
    x2: 120.53,
    y2: 27.0709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_596_5603",
    x1: 104.415,
    y1: 7.07716,
    x2: 99.31,
    y2: 10.3725,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_596_5603",
    x1: 80.2173,
    y1: 0.58079,
    x2: 78.0872,
    y2: 0.96726,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3078FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3078FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_596_5603",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.9377 79.1645) rotate(-18.8432) scale(64.7927)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4586FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0473EA"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationTick);
export default __webpack_public_path__ + "static/media/confirmation-tick.b1211472884c199cc29a60adc4731b72.svg";
export { ForwardRef as ReactComponent };